import React, { useContext, useReducer } from "react";
import classes from "./Home.module.scss";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/Headers/PageHeader";
import PageMain from "../../../components/Main/PageMain";
import Spinner from "../../../components/Spinner";
import TabFirstEvaluation from "./TabFirstEvaluation";
import TabSecondEvaluation from "./TabSecondEvaluation";
import TabTraining from "./TabTraining";
import TabSmartTraining from "./TabSmartTraining";
import UserTrainingContext from "../../../context/userTrainingContext";
// import Title from "../../../components/Title";

const SET_STAGE_1_FIRST_EVALUATION = "SET_STAGE_1_FIRST_EVALUATION";
const SET_STAGE_2_TRAINING = "SET_STAGE_2_TRAINING";
const SET_STAGE_3_SECOND_EVALUATION = "SET_STAGE_3_SECOND_EVALUATION";
const SET_STAGE_4_SMART_TRAINING = "SET_STAGE_4_SMART_TRAINING";

interface InitialStateInterface {
  stage: number;
  loading: boolean;
}

const stagesData = {
  1: {
    title: "global.stage_1_title",
    subtitle: "global.stage_1_subtitle",
  },
  2: {
    title: "global.training",
    subtitle: "global.stage_2_subtitle",
  },
  3: {
    title: "global.stage_3_title",
    subtitle: "global.stage_3_subtitle",
  },
  4: {
    title: "global.training",
    subtitle: "global.stage_4_subtitle",
  },
} as {
  [key: number]: {
    [key: string]: string;
  };
};

const reducer = (state: InitialStateInterface, action: any) => {
  switch (action.type) {
    case SET_STAGE_1_FIRST_EVALUATION:
      return {
        ...state,
        stage: 1,
      };
    case SET_STAGE_2_TRAINING:
      return {
        ...state,
        stage: 2,
      };
    case SET_STAGE_3_SECOND_EVALUATION:
      return {
        ...state,
        stage: 3,
      };
    case SET_STAGE_4_SMART_TRAINING:
      return {
        ...state,
        stage: 4,
      };

    default:
      return state;
  }
};
export default function Home() {
  const initialState: InitialStateInterface = {
    stage: 2,
    loading: false,
  };

  const { t } = useTranslation();
  const tContext = useContext(UserTrainingContext);
  const [state] = useReducer(reducer, initialState);

  let _contentBottom = <Spinner center />;
  switch (state.stage) {
    case 1:
      _contentBottom = <TabFirstEvaluation />;
      break;
    case 2:
      _contentBottom = <TabTraining />;
      break;
    case 3:
      _contentBottom = <TabSecondEvaluation />;
      break;
    case 4:
      _contentBottom = <TabSmartTraining />;
      break;
    default:
      _contentBottom = <Spinner center />;
      break;
  }
  if (tContext.user_permission === '10') state.stage = 4;
  else if (tContext.user_permission === '01') state.stage = 2;
  if (tContext.request_first_avaliation && tContext.user_permission === '10') state.stage = 1;
  if (tContext.request_second_avaliation && tContext.user_permission === '10') state.stage = 3;
  const _pageSubTitle = t(stagesData[state.stage].subtitle);
  const _steppers = null;


  return (
    <>
      <PageHeader title={t("global.welcome") + " " + String(tContext.registry)} subtitle={_pageSubTitle} />
      <PageMain centerStretch>
        <div className={classes.PageHome}>
          {_steppers}
          <section className={classes.ContentArea}>{_contentBottom}</section>
        </div>
      </PageMain>
    </>
  );
}
